import { z } from "zod";

export const lsThemeSchema = z.enum(["match", "light", "dark"]);

export type LSTheme = z.infer<typeof lsThemeSchema>;
